// HSW debounce script for no duplicate PSP fee in cart 
 
  let addToCartActive = false;
  document.addEventListener('click', function(e) {
    const button = e.target.closest('button[name="add"], .add-to-cart');
    if (button) {
      if (addToCartActive) {
        e.stopImmediatePropagation();
        e.preventDefault();
        return;
      }
      addToCartActive = true;
      setTimeout(() => { addToCartActive = false; }, 3000); // 3 second lockout
    }
  }, true); // The 'true' ensures we catch the event early
 
 